<template>
    <div>
        
        <ComponentNavbaraAdmin/>

        <main style="position: relative; left:250px; max-width: calc(100% - 250px);">
            <router-view />
        </main>

    </div>
</template>

<script>
import ComponentNavbaraAdmin from '../components/admin/ComponentNavbaraAdmin.vue';

export default {
    components: {
        ComponentNavbaraAdmin
    },
    name: 'LayoutAdmin',
}
</script>

<style scoped>

</style>